import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Form, Input, Table } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import ShadowCard from '@/components/ShadowCard';
import SvgIcon from '@/components/SvgIcon';
import { getZookeeperList } from '@/services/kopZookeeperService';
import { renderDateTime, renderNum } from '@/utils/common';
import ColTip from '@/components/Tip';
import useTable from '@/hooks/useTable';
import Dashboard from '../Dashboard';
import Detail from './Detail';

const { FormItem } = Form;

export default function Body({ clusterName }) {
  const [visible, setVisible] = useState(false);
  const [currentRow, setCurrentRow] = useState({});

  const columns = [
    {
      colKey: 'host',
      title: '地址',
      sorter: true,
      fixed: 'left',
      cell: ({ row }) => <Detail detail={row} clusterName={clusterName} />,
    },
    {
      colKey: 'port',
      title: '端口',
      sorter: true,
      cell: ({ row }) => (
        <>
          {row.port}, {row.metricsPort}
        </>
      ),
    },
    {
      colKey: 'version',
      title: '版本',
      sorter: true,
    },
    {
      colKey: 'znodeCount',
      title: 'Znode个数',
      sortType: 'all',
      sorter: true,
      cell: renderNum,
    },
    {
      colKey: 'watchCount',
      title: 'watch个数',
      sortType: 'all',
      sorter: true,
      cell: renderNum,
    },
    {
      colKey: 'role',
      title: 'Role',
    },
    {
      colKey: 'createTime',
      title: <ColTip content='第一次采集时间'>创建时间</ColTip>,
      sorter: true,
      cell: renderDateTime,
      width: 180,
    },
    {
      colKey: 'updateTime',
      title: <ColTip content='非实时，有分钟级延迟'>采集时间</ColTip>,
      cell: renderDateTime,
      width: 180,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) => (
        <Icon
          type='presentation-chart-line'
          size={18}
          onClick={() => {
            setVisible(true);
            setCurrentRow(row);
          }}
        />
      ),
      width: 60,
    },
  ];

  const loadData = useMemoizedFn(async (params = {}) => {
    const { data } = await getZookeeperList({ ...params, clusterName });
    setData(
      data.zkMetricsList.map((item) => ({
        ...item,
        role: item.role || '-',
      })),
    );
  });

  const { header, config, setData, doSearch } = useTable({
    search: (
      <FormItem name='host'>
        <Input placeholder='请输入Host' clearable />
      </FormItem>
    ),
    columns,
    onSearch: loadData,
  });

  useEffect(() => {
    if (clusterName) {
      doSearch();
    }
  }, [clusterName, doSearch]);

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <Root>
      {header}
      <Table {...config} />
      <Dashboard
        clusterName={clusterName}
        detail={currentRow}
        visible={visible}
        handleClose={handleClose}
      />
    </Root>
  );
}
const Root = styled(ShadowCard)`
  flex: 1;
  margin-top: 12px;
`;

const Icon = styled(SvgIcon)`
  cursor: pointer;
  color: #194dff;
`;
